// extracted by mini-css-extract-plugin
export default {"templateItemContainer":"IssueTemplateItem-module__templateItemContainer--_dwDr","actionListTitle":"IssueTemplateItem-module__actionListTitle--mKoCB"};